import React, { useState, useEffect } from "react";
import useTitanApp from "../../../../hooks/useTitanApp";
import moment from "moment";
import PrescriptionTemplate from "./PrescriptionTemplate";
import {
  addVaccineDosage,
  getVaccineInfo,
  setSelectedVaccineDose,
  setSelectedVaccineTitle,
  setShowVaccineBasket,
  setShowVaccinePrescription,
} from "../../../../dispatchers/nmsDispatchers";

const CustomVaccineInfo = ({ item, AddVaccineDosage, SectionTitle }) => {
  const { nmsServiceState } = useTitanApp();
  const {
    pharmacyProducts,
    showVaccinePrescription,
    selectedVaccineDose,
    SelectedVaccineTitle,
    vaccineInfo,
    clinicalServiceId,
  } = nmsServiceState;
  const { products } = pharmacyProducts || [];
  const [doses, setDoses] = useState([]);
  const vaccine = products
    ?.flatMap((disease) => disease?.vaccines)
    .find((vaccine) => vaccine?.vaccineName === item?.label);
  const doseSchedule = vaccine?.doseSchedule || 1;
  const nextDoseDuration = parseInt(vaccine?.nextDoseDuration) || 30;
  useEffect(() => {
    const updatedDoses = Array.from({ length: doseSchedule }, (_, index) => {
      let isAdded = vaccineInfo?.some(
        (vaccine) =>
          vaccine?.vaccineName === item?.label && vaccine?.dose === index + 1
      );
      if (!isAdded) {
        isAdded = selectedVaccineDose?.some(
          (vaccine) =>
            vaccine?.label === item?.label && vaccine?.id === index + 1
        );
      }
      return {
        id: index + 1,
        label: `Dose ${index + 1}`,
        time: index === 0 ? "Today" : `${nextDoseDuration * index} days`,
        date: moment()
          .add(nextDoseDuration * index, "days")
          .format("D MMMM"),
        price: `£${vaccine?.price || "0.00"}`,
        isAdded,
      };
    });

    setDoses(updatedDoses);
  }, [pharmacyProducts, selectedVaccineDose]);
  const handleOpenPopup = (dose, title) => {
    const prevDoses = selectedVaccineDose || [];
    const prevTitle = SelectedVaccineTitle || [];
    setSelectedVaccineDose([...prevDoses, { ...dose, label: title }]);
    setShowVaccineBasket(true);
    setSelectedVaccineTitle(item?.label);
    const updatedDosage = doses.map((newDose) =>
      newDose?.id === dose?.id ? { ...newDose, isAdded: true } : newDose
    );
    setDoses(updatedDosage);
    if (dose?.id === 1) {
      AddVaccineDosage(title, SectionTitle);
    }
  };

  useEffect(() => {
    if (showVaccinePrescription) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showVaccinePrescription]);

  const handleClosePrescription = () => {
    setShowVaccinePrescription(false);
  };

  return (
    <div className="dose-schedule-container">
      <header className="header">
        <span className="dose-title">{item?.label}</span>
        <div className="stock-info">
          <span>{vaccine?.stockQuantity} in stock</span>
        </div>
      </header>

      <div className="dose-list">
        {doses?.map((dose) => (
          <div key={dose.id} className="dose-item">
            <div className="dose-info">
              <span className="dose-label">{dose?.label}</span>
              <span className="dose-info-content">{dose?.time}</span>
              <span className="dose-info-content">{dose?.date}</span>
            </div>
            <button
              disabled={dose?.isAdded}
              className={dose?.isAdded ? "dose-button-disable" : "dose-button"}
              onClick={() => handleOpenPopup(dose, item?.label)}
            >
              {dose?.price} - ADD
            </button>
          </div>
        ))}
      </div>
      {showVaccinePrescription && (
        <div className="popup-overlay">
          <div className="popup-content">
            <PrescriptionTemplate
              handleClosePrescription={handleClosePrescription}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomVaccineInfo;
